import React from 'react';
import Step2 from './Step2';
import Step3 from './Step3';
import Step4 from './Step4';
import Step5 from './Step5';
import Step6 from './Step6';
import Step7 from './Step7';
import Steps8to11 from './Steps8to11';
import Steps11to14 from './Steps11to14';
import type { Project } from './types';

interface Props {
  n: number;
  p: Project;
  onPatch: (patch: Partial<Project>) => void;
  toast: (m: string) => void;
  masterOpen: boolean;
  onToggleMaster: () => void;
  onPv: (k: string, idx?: number) => void;
  onVer: (k: string) => void;
  onFilePv: (name: string, title?: string) => void;
}

export default function StepBody({ n, p, onPatch, toast, masterOpen, onToggleMaster, onPv, onVer, onFilePv }: Props) {
  if (n === 2) return <Step2 p={p} onPatch={onPatch} toast={toast} onFilePv={onFilePv} />;
  if (n === 3) return <Step3 p={p} onPatch={onPatch} toast={toast} masterOpen={masterOpen} onToggleMaster={onToggleMaster} onPv={onPv} onVer={onVer} onFilePv={onFilePv} />;
  if (n === 4) return <Step4 p={p} onPatch={onPatch} toast={toast} masterOpen={masterOpen} onToggleMaster={onToggleMaster} onPv={onPv} onVer={onVer} onFilePv={onFilePv} />;
  if (n === 5) return <Step5 p={p} onPatch={onPatch} toast={toast} masterOpen={masterOpen} onToggleMaster={onToggleMaster} onPv={onPv} onVer={onVer} onFilePv={onFilePv} />;
  if (n === 6) return <Step6 p={p} onPatch={onPatch} toast={toast} />;
  if (n === 7) return <Step7 p={p} onPatch={onPatch} toast={toast} masterOpen={masterOpen} onToggleMaster={onToggleMaster} onPv={onPv} onVer={onVer} onFilePv={onFilePv} />;
  if (n >= 8 && n <= 10) return <Steps8to11 n={n as 8 | 9 | 10} p={p} onPatch={onPatch} toast={toast} masterOpen={masterOpen} onToggleMaster={onToggleMaster} onFilePv={onFilePv} />;
  if (n >= 11 && n <= 15) return <Steps11to14 n={n as 11 | 12 | 13 | 14 | 15} p={p} onPatch={onPatch} toast={toast} />; // 법인별 진도 5단계 (13 VICS 보고 삽입, 2026-09-24)
  return null;
}
